(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nosferatu-card-game"] && !Shopify.designMode) return;
  try {
    
/* =========================================================================
   NOSFERATU — THE COUNT'S PATIENCE
   One custom element. No globals beyond the guarded customElements.define and
   a namespaced sessionStorage key. Nothing on window, nothing on document
   except the Esc/Tab handlers this element attaches and removes itself.
   ========================================================================= */
(function () {
  var MOTIFS = ['orlok', 'bat', 'coffin', 'key', 'castle', 'ship'];
  var PAIRS = MOTIFS.length;
  var MISMATCH_MS = 950;

  /* ---------------------------------------------- REVISION 6, ITEM B --------
     AUTO-OPEN FOR EMAIL ARRIVALS. The launch emails send two different
     audiences to this page with the variant recorded in two different
     parameters: the Inner Circle sends carry `utm_term=ic-card`, the
     non-member sends carry `utm_content=nonic-card`, and both audiences may
     also arrive on a short `?deal=1` link.

     THREE RULES THAT ARE NOT NEGOTIABLE:
       1. EXACT match, never substring. `utm_term=ic-card-control` is a
          different creative and must not open anything; `nonic-card` is a
          substring of nothing we own today, but that is luck, not a design.
          Values are trimmed and lower-cased first, then compared whole.
       2. These are CREATIVE labels, never MEMBER signals. `ic-card` says which
          email was clicked, not who clicked it — a forwarded email is the
          ordinary case. Membership is decided server-side from customer tags
          (see the Liquid at the top of this file) and nothing here touches it.
       3. The LETTER variants (`ic-letter` / `nonic-letter`) point at a
          different part of the page and deliberately do NOT open the game.
     ------------------------------------------------------------------------ */
  var AUTO_OPEN_MS = 1500;
  var AUTO_OPEN_KEYS = ['utm_term', 'utm_content'];
  var AUTO_OPEN_VALUES = ['ic-card', 'nonic-card'];

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function NosferatuCardGameFactory() {
    return class NosferatuCardGame extends HTMLElement {
      connectedCallback() {
        if (this.booted) return;
        this.booted = true;

        var d = this.dataset;
        this.isMember = d.member === 'true';
        this.words = {
          card: d.cardWord || 'Plate',
          faceDown: d.faceDown || 'face down',
          matched: d.matchedWord || 'matched',
          pair: d.announcePair || 'A pair.',
          noPair: d.announceNoPair || 'No pair.',
          win: d.announceWin || 'Every pair is found.',
          dealt: d.announceDealt || 'Twelve plates dealt, face down.',
          copy: d.copyLabel || 'Copy code',
          copied: d.copiedLabel || 'Copied',
          copyFailed: d.copyFailedLabel || 'Select and copy the code'
        };
        this.names = {
          orlok: d.motifOrlok || 'Count Orlok',
          bat: d.motifBat || 'the bat',
          coffin: d.motifCoffin || 'the coffin',
          key: d.motifKey || 'the coffin key',
          castle: d.motifCastle || 'the castle',
          ship: d.motifShip || 'the ship'
        };

        this.dock = this.querySelector('[data-nos-game-dock]');
        this.openBtn = this.querySelector('[data-nos-game-open]');
        this.dismissBtn = this.querySelector('[data-nos-game-dismiss]');
        this.scrim = this.querySelector('[data-nos-game-scrim]');
        this.dialog = this.querySelector('[data-nos-game-dialog]');
        this.closeBtn = this.querySelector('[data-nos-game-close]');
        this.board = this.querySelector('[data-nos-game-board]');
        this.intro = this.querySelector('[data-nos-game-intro]');
        this.reward = this.querySelector('[data-nos-game-reward]');
        this.live = this.querySelector('[data-nos-game-live]');
        this.triesNode = this.querySelector('[data-nos-game-tries]');
        this.invertBtn = this.querySelector('[data-nos-game-invert]');
        this.againBtn = this.querySelector('[data-nos-game-again]');
        this.copyBtn = this.querySelector('[data-nos-game-copy]');
        this.codeNode = this.querySelector('[data-nos-game-code]');
        this.rewardTitle = this.querySelector('[data-nos-game-reward-title]');
        this.plates = this.querySelector('[data-nos-game-plates]');
        if (!this.dock || !this.dialog || !this.board || !this.plates) return;

        /* Lift the plate markup out of the inert library, then drop the
           library from the DOM entirely so nothing decorative lingers. */
        this.art = {};
        var wells = this.plates.querySelectorAll('[data-plate]');
        for (var i = 0; i < wells.length; i++) {
          this.art[wells[i].getAttribute('data-plate')] = wells[i].innerHTML;
        }
        this.plates.parentNode.removeChild(this.plates);

        this.reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.applyReduce();
        if (this.reduceQuery.addEventListener) {
          this.reduceQuery.addEventListener('change', this.applyReduce.bind(this));
        }

        this.state = this.readState();
        this.setInvert(!!this.state.invert, true);

        this.first = null;
        this.locked = false;
        this.tries = 0;
        this.matched = 0;
        this.dealt = false;

        this.onKeydown = this.handleKeydown.bind(this);
        this.openBtn.addEventListener('click', this.open.bind(this));
        this.dismissBtn.addEventListener('click', this.dismiss.bind(this));
        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.scrim.addEventListener('click', this.close.bind(this));
        this.invertBtn.addEventListener('click', this.toggleInvert.bind(this));
        this.againBtn.addEventListener('click', this.dealAgain.bind(this));
        this.board.addEventListener('click', this.handleBoardClick.bind(this));
        if (this.copyBtn) this.copyBtn.addEventListener('click', this.copyCode.bind(this));

        /* Revision 5, item 8. Two things the fixed tab has to stay out of the
           way of, both wired before it is ever shown. */
        this.watchOverlays();
        this.measureFoot();

        if (!this.state.dismissed) {
          var delay = parseInt(d.triggerDelay, 10);
          if (isNaN(delay) || delay < 0) delay = 3;
          this.revealTimer = window.setTimeout(this.revealDock.bind(this), delay * 1000);
        }

        this.scheduleAutoOpen();
      }

      /* ------------------------------------------------ REVISION 6, ITEM B --
         The read of the query string. Deliberately narrow: one `deal` value,
         two parameter names, two creative labels, all matched whole. Anything
         that throws (a malformed query string, a sandbox with no
         URLSearchParams) simply means "no auto-open" — never an exception on
         a page that is otherwise fine. */
      autoOpenRequested() {
        var params;
        try {
          var search = (window.location && window.location.search) || '';
          if (!search) return false;
          params = new URLSearchParams(search);
        } catch (e) {
          return false;
        }

        try {
          if (String(params.get('deal') || '').trim() === '1') return true;
          for (var k = 0; k < AUTO_OPEN_KEYS.length; k++) {
            var raw = params.get(AUTO_OPEN_KEYS[k]);
            if (raw === null) continue;
            var value = String(raw).trim().toLowerCase();
            for (var v = 0; v < AUTO_OPEN_VALUES.length; v++) {
              if (value === AUTO_OPEN_VALUES[v]) return true;
            }
          }
        } catch (e) { /* fall through to false */ }
        return false;
      }

      /* Anything modal that is already up wins. The test is the one from
         syncEclipse, minus our own dialog: the scroll lock that every overlay
         on this page sets, plus the named overlays for any that does not.
         The GATE is the one that matters — an unknown visitor who has already
         been intercepted must not have a second dialog thrown over the first.
         Note this is a one-way courtesy: the game standing down here does not
         suppress the gate later. The gate is driven entirely by the core
         section and is never consulted, disabled or delayed from in here. */
      otherOverlayOpen() {
        if (document.documentElement.style.overflow === 'hidden') return true;
        if (document.body && document.body.style.overflow === 'hidden') return true;
        var nodes = this.overlayNodes();
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i] && nodes[i] !== this.dialog && !nodes[i].hidden) return true;
        }
        return false;
      }

      scheduleAutoOpen() {
        if (!this.autoOpenRequested()) return;
        if (this.state.won || this.state.dismissed || this.state.autoOpened) return;
        this.autoOpenTimer = window.setTimeout(this.autoOpen.bind(this), AUTO_OPEN_MS);
      }

      autoOpen() {
        this.autoOpenTimer = null;
        /* Re-read the guards at firing time, not at scheduling time: 1.5s is
           long enough for the visitor to have dismissed the tab, won on a
           second element, or been caught by the gate. */
        if (this.state.won || this.state.dismissed || this.state.autoOpened) return;
        if (!this.dialog.hidden) return;
        if (this.otherOverlayOpen()) return;

        this.state.autoOpened = true;
        this.saveState();

        /* The dock is revealed first so that closing the dialog leaves a tab
           behind rather than nothing. Under reduced motion the two land
           together — the game still opens, it just skips the small beat that
           lets the tab arrive before the dialog does. */
        if (this.revealTimer) {
          window.clearTimeout(this.revealTimer);
          this.revealTimer = null;
        }
        this.revealDock();

        if (this.reduced) {
          this.open();
        } else {
          this.autoOpenTimer = window.setTimeout(function () {
            this.autoOpenTimer = null;
            if (this.dialog.hidden && !this.otherOverlayOpen()) this.open();
          }.bind(this), 220);
        }
      }

      /* ------------------------------------------------ REVISION 5, ITEM 8 --
         (a) DIALOGS. The dock's z-index is deliberately at the top of the
         stack, which means it would otherwise float over every modal on the
         page — our gate (z 100), the ring lightbox (120), the theme's login
         popup (9999), the proof section's own dialogs, and this game's dialog.

         The signal used is the one thing all of them already do and none of
         them can do accidentally: they lock the document's scroll. The story
         and proof sections set `documentElement.style.overflow = 'hidden'`;
         the theme's login modal sets it on `body`. So the observer watches the
         `style` attribute of exactly two nodes — cheap, precise, and it needs
         no knowledge of any other section's class names. The named dialogs are
         checked as well, so a future dialog that does not lock scrolling is
         still covered.

         (b) THE FOOT OF THE WINDOW. A cookie-consent banner is fixed, arrives
         late, and lands in the same corner. Rather than guess at a clearance,
         the real occupant is measured and the dock lifts by exactly its height
         — and by nothing at all when there is none.
         ---------------------------------------------------------------- */
      overlayNodes() {
        return [
          document.getElementById('fj-login-modal'),
          document.querySelector('.nos-gate'),
          document.querySelector('.nos-lightbox'),
          this.dialog
        ];
      }

      syncEclipse() {
        var locked = document.documentElement.style.overflow === 'hidden' ||
          (document.body && document.body.style.overflow === 'hidden');
        if (!locked) {
          var nodes = this.overlayNodes();
          for (var i = 0; i < nodes.length; i++) {
            if (nodes[i] && !nodes[i].hidden) { locked = true; break; }
          }
        }
        this.dock.classList.toggle('is-eclipsed', !!locked);
      }

      watchOverlays() {
        this.syncEclipse = this.syncEclipse.bind(this);
        this.measureFoot = this.measureFoot.bind(this);
        /* measureFoot walks a handful of selectors and reads computed styles.
           `childList` on <body> fires for every script that appends anything,
           so the work is coalesced into one frame rather than run per record. */
        /* A timer, deliberately, not requestAnimationFrame: rAF does not fire
           while the tab is in the background, and a consent banner that is
           injected there would then never be measured until the visitor came
           back and moved something. */
        this.queueMeasure = function () {
          if (this.measureQueued) return;
          this.measureQueued = window.setTimeout(function () {
            this.measureQueued = null;
            this.measureFoot();
          }.bind(this), 60);
        }.bind(this);

        if (!window.MutationObserver) return;
        this.overlayObserver = new MutationObserver(function () {
          this.syncEclipse();
          this.queueMeasure();
        }.bind(this));
        var attrs = { attributes: true, attributeFilter: ['style', 'hidden', 'class'] };
        this.overlayObserver.observe(document.documentElement, attrs);
        if (document.body) {
          /* childList, NOT subtree: a consent banner is injected as a direct
             child of <body>. Watching the whole subtree would fire on every
             DOM write on the page for one late-arriving element. */
          this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'hidden', 'class'], childList: true });
        }
        window.addEventListener('resize', this.measureFoot, { passive: true });
        /* A consent banner injected deeper than <body>, or after its own
           script loads, is caught by these three sweeps rather than by an
           expensive permanent subtree observer. */
        this.footSweeps = [800, 2500, 6000].map(function (ms) {
          return window.setTimeout(this.measureFoot, ms);
        }.bind(this));
      }

      /* Known consent-banner containers, plus a generic sweep of the bottom
         strip. Only elements that are actually FIXED, actually visible and
         actually overlapping the dock's corner count — a banner that has been
         dismissed, or one docked to the top, moves nothing. */
      measureFoot() {
        if (!this.dock) return;
        var candidates = [];
        var selectors = [
          '#shopify-pc__banner',
          '.shopify-pc__banner',
          '#onetrust-banner-sdk',
          '#CybotCookiebotDialog',
          '#usercentrics-root',
          '.cookie-banner',
          '.cookie-consent',
          '#cookie-banner',
          '[data-cookie-banner]',
          '[aria-label*="cookie" i][role="dialog"]'
        ];
        for (var s = 0; s < selectors.length; s++) {
          var found;
          try { found = document.querySelectorAll(selectors[s]); } catch (e) { found = []; }
          for (var i = 0; i < found.length; i++) candidates.push(found[i]);
        }
        var vh = window.innerHeight || 0;
        var vw = window.innerWidth || 0;
        var lift = 0;
        for (var c = 0; c < candidates.length; c++) {
          var el = candidates[c];
          if (!el || el.hidden || el === this.dock || this.contains(el)) continue;
          var cs = window.getComputedStyle(el);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
          var r = el.getBoundingClientRect();
          if (!r.height || !r.width) continue;
          // must reach the bottom of the window and the dock's side of it
          if (r.bottom < vh - 4) continue;
          if (r.right < vw - 220) continue;
          var overlap = vh - r.top;
          if (overlap > lift) lift = overlap;
        }
        lift = Math.max(0, Math.min(Math.round(lift), Math.round(vh * 0.6)));
        this.dock.style.setProperty('--nos-game-lift', lift ? lift + 8 + 'px' : '0px');
      }

      /* ------------------------------------------------------- persistence */
      storageKey() {
        return 'nosferatu-card-game:' + (window.location && window.location.pathname ? window.location.pathname : '/');
      }

      readState() {
        try {
          var raw = window.sessionStorage.getItem(this.storageKey());
          if (!raw) return { won: false, dismissed: false, invert: false, autoOpened: false };
          var parsed = JSON.parse(raw);
          return {
            won: !!parsed.won,
            dismissed: !!parsed.dismissed,
            invert: !!parsed.invert,
            /* Revision 6, item B. Written only when the dialog actually opens
               itself, so a visit where the gate held it back is not counted as
               a firing — the next page in the same session may still open it,
               which is the behaviour we want. A visitor who arrives on the
               link twice in one session is not shown it twice. */
            autoOpened: !!parsed.autoOpened
          };
        } catch (e) {
          return { won: false, dismissed: false, invert: false, autoOpened: false };
        }
      }

      saveState() {
        try {
          window.sessionStorage.setItem(this.storageKey(), JSON.stringify(this.state));
        } catch (e) { /* private mode, quota, blocked cookies — the game still plays */ }
      }

      /* ------------------------------------------------------------ chrome */
      applyReduce() {
        this.reduced = this.reduceQuery.matches;
        this.classList.toggle('nos-game-reduce', this.reduced);
      }

      revealDock() {
        if (this.state.dismissed) return;
        this.dock.hidden = false;
      }

      dismiss() {
        this.dock.hidden = true;
        this.state.dismissed = true;
        this.saveState();
      }

      setInvert(on, silent) {
        this.classList.toggle('is-inverted', !!on);
        this.invertBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        this.state.invert = !!on;
        if (!silent) this.saveState();
      }

      toggleInvert() {
        this.setInvert(!this.state.invert, false);
      }

      announce(message) {
        if (this.live) this.live.textContent = message;
      }

      /* ------------------------------------------------------------ dialog */
      open() {
        this.lastFocus = document.activeElement;
        this.scrim.hidden = false;
        this.dialog.hidden = false;
        document.addEventListener('keydown', this.onKeydown, true);
        /* Revision 5, item 8: the dock stands down behind our own dialog too —
           the dialog's `hidden` attribute is not one of the two nodes the
           observer watches, so say so explicitly. */
        this.syncEclipse();

        if (this.state.won) {
          this.showReward(false);
        } else {
          this.showBoard();
          if (!this.dealt) this.deal();
        }

        var focusables = this.focusables();
        if (focusables.length) focusables[0].focus();
      }

      close() {
        if (this.dialog.hidden) return;
        this.dialog.hidden = true;
        this.scrim.hidden = true;
        document.removeEventListener('keydown', this.onKeydown, true);
        this.syncEclipse();
        /* Return focus where it came from. `document.body` is not a real
           previous focus (it is what activeElement reads as when the dialog was
           opened programmatically or by a pointer that did not focus the
           trigger), so in that case fall back to the trigger itself rather than
           dropping the caret at the top of the document. */
        var back = this.lastFocus;
        if (!back || back === document.body || !document.contains(back) || typeof back.focus !== 'function') {
          back = this.dock.hidden ? null : this.openBtn;
        }
        if (back) back.focus();
      }

      focusables() {
        var nodes = this.dialog.querySelectorAll(FOCUSABLE);
        var out = [];
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.hidden || n.closest('[hidden]')) continue;
          if (!n.offsetParent && n.offsetWidth === 0 && n.offsetHeight === 0) continue;
          out.push(n);
        }
        return out;
      }

      handleKeydown(event) {
        if (this.dialog.hidden) return;
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        var list = this.focusables();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        var active = document.activeElement;
        if (event.shiftKey && (active === first || !this.dialog.contains(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || !this.dialog.contains(active))) {
          event.preventDefault();
          first.focus();
        }
      }

      /* -------------------------------------------------------------- deal */
      showBoard() {
        this.board.hidden = false;
        this.intro.hidden = false;
        this.reward.hidden = true;
      }

      showReward(fromWin) {
        this.board.hidden = true;
        this.intro.hidden = true;
        this.reward.hidden = false;
        /* The board that held focus has just been hidden, so focus would fall
           to <body>. Move it onto the reward heading (tabindex="-1") so the
           reward is what gets read out, not the close button. */
        if (fromWin && this.rewardTitle) this.rewardTitle.focus();
      }

      deal() {
        var deck = MOTIFS.concat(MOTIFS);
        for (var i = deck.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var swap = deck[i];
          deck[i] = deck[j];
          deck[j] = swap;
        }
        while (this.board.firstChild) this.board.removeChild(this.board.firstChild);
        for (var k = 0; k < deck.length; k++) this.board.appendChild(this.makeCard(deck[k], k));
        this.first = null;
        this.locked = false;
        this.tries = 0;
        this.matched = 0;
        this.dealt = true;
        this.updateTries();
        this.announce(this.words.dealt);
      }

      makeCard(motif, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nos-game-card';
        btn.setAttribute('data-motif', motif);
        btn.setAttribute('data-index', String(index));
        btn.setAttribute('aria-label', this.cardLabel(index, 'down', motif));

        var inner = document.createElement('span');
        inner.className = 'nos-game-card__inner';

        var back = document.createElement('span');
        back.className = 'nos-game-card__face nos-game-card__face--back';
        back.innerHTML = this.art.back || '';

        var front = document.createElement('span');
        front.className = 'nos-game-card__face nos-game-card__face--front';
        front.innerHTML = this.art[motif] || '';

        inner.appendChild(back);
        inner.appendChild(front);
        btn.appendChild(inner);
        return btn;
      }

      cardLabel(index, mode, motif) {
        var head = this.words.card + ' ' + (index + 1) + ', ';
        if (mode === 'down') return head + this.words.faceDown;
        if (mode === 'matched') return head + this.names[motif] + ', ' + this.words.matched;
        return head + this.names[motif];
      }

      updateTries() {
        if (this.triesNode) this.triesNode.textContent = String(this.tries);
      }

      /* -------------------------------------------------------------- play */
      handleBoardClick(event) {
        var card = event.target.closest ? event.target.closest('.nos-game-card') : null;
        if (!card || !this.board.contains(card)) return;
        this.flip(card);
      }

      flip(card) {
        if (this.locked) return;
        if (card.classList.contains('is-matched') || card.classList.contains('is-face-up')) return;

        var motif = card.getAttribute('data-motif');
        var index = parseInt(card.getAttribute('data-index'), 10);
        card.classList.add('is-face-up');
        card.setAttribute('aria-label', this.cardLabel(index, 'up', motif));
        this.announce(this.names[motif] + '.');

        if (!this.first) {
          this.first = card;
          return;
        }

        this.tries += 1;
        this.updateTries();
        var firstCard = this.first;
        this.first = null;

        if (firstCard.getAttribute('data-motif') === motif) {
          this.resolveMatch(firstCard, card, motif);
          return;
        }

        this.locked = true;
        var self = this;
        window.setTimeout(function () {
          [firstCard, card].forEach(function (node) {
            node.classList.remove('is-face-up');
            node.setAttribute('aria-label', self.cardLabel(parseInt(node.getAttribute('data-index'), 10), 'down', node.getAttribute('data-motif')));
          });
          self.locked = false;
        }, this.reduced ? 700 : MISMATCH_MS);
        this.announce(this.words.noPair);
      }

      resolveMatch(a, b, motif) {
        [a, b].forEach(function (node) {
          node.classList.remove('is-face-up');
          node.classList.add('is-matched');
          node.disabled = true;
        });
        var self = this;
        [a, b].forEach(function (node) {
          node.setAttribute('aria-label', self.cardLabel(parseInt(node.getAttribute('data-index'), 10), 'matched', motif));
        });
        this.matched += 1;
        if (this.matched >= PAIRS) {
          this.win();
        } else {
          this.announce(this.words.pair + ' ' + this.names[motif] + '.');
        }
      }

      win() {
        this.state.won = true;
        this.saveState();
        this.announce(this.words.win);
        var self = this;
        window.setTimeout(function () { self.showReward(true); }, this.reduced ? 0 : 620);
      }

      dealAgain() {
        this.showBoard();
        this.deal();
        var firstCard = this.board.querySelector('.nos-game-card');
        if (firstCard) firstCard.focus();
      }

      /* -------------------------------------------------------------- code */
      copyCode() {
        if (!this.codeNode || !this.copyBtn) return;
        var value = (this.codeNode.textContent || '').trim();
        var self = this;
        var settled = false;
        var done = function (ok) {
          if (settled) return;
          settled = true;
          if (!ok) self.selectCode();
          self.copyBtn.textContent = ok ? self.words.copied : self.words.copyFailed;
          self.announce(ok ? self.words.copied + ': ' + value : self.words.copyFailed + ': ' + value);
          window.setTimeout(function () { self.copyBtn.textContent = self.words.copy; }, 2600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          /* The Clipboard API can reject, and in some embedded/permission-gated
             contexts it neither resolves nor rejects. Never leave the button
             silent: fall back to selecting the code if it has not settled. */
          window.setTimeout(function () { done(false); }, 700);
          navigator.clipboard.writeText(value).then(function () { done(true); }, function () { done(false); });
          return;
        }
        done(false);
      }

      selectCode() {
        try {
          var range = document.createRange();
          range.selectNodeContents(this.codeNode);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } catch (e) { /* selection is a convenience, never a requirement */ }
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown, true);
        if (this.revealTimer) window.clearTimeout(this.revealTimer);
        /* Revision 6, item B: the auto-open beat is a timer like any other. */
        if (this.autoOpenTimer) window.clearTimeout(this.autoOpenTimer);
        /* Revision 5, item 8: the overlay watcher is document-level, so it has
           to come down with the element. */
        if (this.overlayObserver) this.overlayObserver.disconnect();
        window.removeEventListener('resize', this.measureFoot);
        (this.footSweeps || []).forEach(function (id) { window.clearTimeout(id); });
        if (this.measureQueued) window.clearTimeout(this.measureQueued);
      }
    };
  }

  if (!customElements.get('nosferatu-card-game')) {
    customElements.define('nosferatu-card-game', NosferatuCardGameFactory());
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosferatu-membership-proof"] && !Shopify.designMode) return;
  try {
    
  class NosferatuProof extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return
      this.dataset.ready = 'true'

      // ---- State: UTM presents, Liquid tags authorize. A UTM NEVER authorizes. ----
      const query = new URLSearchParams(window.location.search)
      const memberSignals = [query.get('ic_member'), query.get('utm_content')]
        .filter(Boolean)
        .map((value) => value.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_'))
      const memberEmailView = memberSignals.some((value) => ['1', 'true', 'ic_member', 'active_ic_member', 'active_inner_circle_member'].includes(value))
      if (memberEmailView) this.classList.add('is-member-view')
      this.memberView = this.classList.contains('is-member-view')
      this.memberAuthorized = this.dataset.memberAuthorized === 'true'
      if (this.memberAuthorized) this.classList.add('is-member-authorized')

      /* REVISION 4, ITEM 9 — day mode, read not decided.
         The story section owns the three-state display cycle and writes the
         result to <html data-nos-display>, which is the only node both sections
         and the four portalled dialogs can see. This reads the same
         sessionStorage key so the section is still correct on a template where
         the story section is absent, or has not initialised yet — and it never
         overwrites a value the story section has already set. Every day rule in
         this file's stylesheet keys off that one attribute, so there is nothing
         further to keep in sync. */
      this.syncDisplayState()

      this.sellingPlan = Number(this.dataset.sellingPlan || 0) || 0
      this.knownBoxIds = String(this.dataset.boxIds || '')
        .split(',')
        .map((value) => Number(value.trim()))
        .filter((value) => value > 0)

      // UTM-only member view: archive commerce is off, and an attempted action
      // invites the visitor to sign in rather than pretending to be a purchase.
      if (this.memberView && !this.memberAuthorized) {
        this.querySelectorAll('[data-archive-box]').forEach((button) => {
          button.setAttribute('aria-disabled', 'true')
        })
      }

      this.featuredSlides = Array.from(this.querySelectorAll('[data-featured-slide]'))
      this.featuredDots = Array.from(this.querySelectorAll('[data-featured-dot]'))
      this.featuredIndex = 0
      this.track = this.querySelector('[data-box-track]')
      this.sheet = this.querySelector('[data-quick-add]')
      this.signin = this.querySelector('[data-signin]')
      this.sheetImage = this.querySelector('[data-quick-image]')
      this.sheetTitle = this.querySelector('[data-quick-title]')
      this.sheetMonth = this.querySelector('[data-quick-month]')
      this.sheetChoices = this.querySelector('[data-quick-choices]')
      this.sheetSubmit = this.querySelector('[data-quick-submit]')
      this.sheetStatus = this.querySelector('[data-quick-status]')
      this.prospectPrice = this.querySelector('[data-quick-prospect-price]')
      this.submitLabel = this.sheetSubmit ? this.sheetSubmit.textContent : 'Add to cart'

      const signinLink = this.querySelector('[data-signin-link]')
      if (signinLink) {
        const returnUrl = window.location.pathname + window.location.search
        signinLink.href = `${this.dataset.loginUrl || '/account/login'}?return_url=${encodeURIComponent(returnUrl)}`
      }

      /* REVISION 3, ITEM A — make the sign-in controls in this section actually
         sign anybody in.

         The live theme installs a DOCUMENT-level click handler in
         snippets/product-info.liquid:

             var nativeLogin = e.target.closest('a[href^="/account/login"]')
             if (nativeLogin) { var lm = document.getElementById('fj-login-modal')
               if (lm) { e.preventDefault(); lm.hidden = false; return } }

         It cancels EVERY login link on the page and opens the theme's own
         #fj-login-modal instead — a modal that is emitted inside the
         featured-product section and, on this template, ends up hidden inside
         the collapsed crypt card. So both of this section's sign-in links
         ("The Circle knows you" and the exclusives invitation) were cancelled
         and replaced with something invisible.

         Stopping propagation on the anchor keeps the click off `document`, so
         the anchor navigates the way an anchor should. Same fix, same reason,
         as the core section's gate anchor. Nothing global is touched.

         Matching by href rather than by a data attribute means any sign-in link
         added to this section later is covered without anyone remembering to
         wire it.

         ===================== REVISION 4, ITEM 8 =========================
         The client wants the lightbox, not a page change. Reversing round 3
         here was the same deletion as in the core section: the theme's
         document-level handler already opens #fj-login-modal for any click on
         a link to /account/login, and round 3's `stopPropagation()` was the
         only thing starving it. It is gone. Two things are done on the way
         through instead:

           · the section's own sign-in dialog is closed first, so the popup
             never opens behind it (this section is the only one with a dialog
             that itself contains a sign-in link);
           · the login form's `return_to` is pointed back at this page.

         The fallback is the same and is structural, not defensive: the modal
         is emitted by snippets/product-info.liquid only for a logged-out
         visitor on a product that shows member benefits, so it can be missing.
         When it is, the theme handler does nothing, and these are still real
         anchors carrying a `return_url` — they simply navigate, exactly as
         they did in round 3. */
      this.querySelectorAll('a[href*="/account/login"]').forEach((link) => {
        if (link.dataset.nfSigninWired === 'true') return
        link.dataset.nfSigninWired = 'true'
        link.addEventListener('click', () => {
          if (this.signin && !this.signin.hidden) this.closeSignin()
          this.primeThemeLogin()
        })
      })

      this.querySelector('[data-featured-prev]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex - 1))
      this.querySelector('[data-featured-next]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex + 1))
      this.featuredDots.forEach((dot) => dot.addEventListener('click', () => this.showFeatured(Number(dot.dataset.featuredDot))))
      this.querySelector('[data-box-prev]')?.addEventListener('click', () => this.scrollBoxes(-1))
      this.querySelector('[data-box-next]')?.addEventListener('click', () => this.scrollBoxes(1))

      this.querySelectorAll('[data-open-quick-add]').forEach((button) => button.addEventListener('click', () => {
        // Members never purchase an archive box on this page.
        if (this.memberView && button.hasAttribute('data-archive-box')) {
          this.openSignin(button)
          return
        }
        this.openQuickAdd(button)
      }))
      this.querySelectorAll('[data-close-quick-add]').forEach((button) => button.addEventListener('click', () => this.closeQuickAdd()))
      this.querySelectorAll('[data-close-signin]').forEach((button) => button.addEventListener('click', () => this.closeSignin()))
      this.sheetSubmit?.addEventListener('click', () => this.addSelection())

      /* ============================ REVISION 5, ITEM 9 ============================
         A qualifying box landing in the cart is the moment a prospect becomes
         eligible for the member exclusives, and until now nothing said so —
         the cards quietly un-blurred somewhere below the fold. The reveal
         takes the visitor to them and opens the iron gate on the way.

         The trigger is the TRANSITION, not the event: `hadBox` starts from a
         server-rendered value, so a page loaded with a box already in the cart
         reveals nothing (there is nothing new to tell), and a cart event that
         does not change the answer is ignored.
         ========================================================================= */
      this.hadBox = this.dataset.cartHasBox === 'true'
      this.revealStorageKey = `nosferatu-exclusives-revealed:${window.location.pathname}`
      this.revealPending = false
      this.revealAttempts = 0
      try {
        this.revealDone = window.sessionStorage.getItem(this.revealStorageKey) === 'true'
      } catch (error) {
        this.revealDone = false
      }

      this.onCartUpdated = (event) => {
        const hasBox = this.cartHasInnerCircleBox(event.detail?.cart)
        if (hasBox || this.memberAuthorized) this.unlockExclusives()
        else this.lockExclusives()
        if (hasBox && !this.hadBox) this.revealExclusives()
        this.hadBox = hasBox
      }
      document.addEventListener('fj:cart-updated', this.onCartUpdated)
      // The theme also emits the un-namespaced event; both are the same signal
      // and the transition guard makes a double fire harmless.
      document.addEventListener('cart:updated', this.onCartUpdated)
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return
        if (this.signin && !this.signin.hidden) this.closeSignin()
        else if (this.sheet && !this.sheet.hidden) this.closeQuickAdd()
      }
      document.addEventListener('keydown', this.onKeydown)
      this.showFeatured(0)
    }

    disconnectedCallback() {
      document.removeEventListener('fj:cart-updated', this.onCartUpdated)
      document.removeEventListener('cart:updated', this.onCartUpdated)
      document.removeEventListener('keydown', this.onKeydown)
      if (this.revealTimer) window.clearTimeout(this.revealTimer)
      if (this.revealWait) window.clearTimeout(this.revealWait)
    }

    /* Reads the display state the story section owns. Never writes it unless
       nothing has set it yet, so the two sections cannot fight. */
    syncDisplayState() {
      const root = document.documentElement
      if (root.dataset.nosDisplay) return
      let stored = null
      try {
        stored = window.sessionStorage.getItem(`nosferatu-display:${window.location.pathname}`)
      } catch (error) {
        stored = null
      }
      if (stored === 'night' || stored === 'stilled' || stored === 'day') {
        root.dataset.nosDisplay = stored
      }
    }

    /* Revision 4, item 8. Returns true when the theme's popup is available and
       has been prepared; false means this click is going to navigate, which is
       the correct outcome rather than an error. Kept deliberately identical in
       shape to the core section's method of the same name. */
    primeThemeLogin() {
      const modal = document.getElementById('fj-login-modal')
      if (!modal) return false
      /* The theme renders the form with `return_to: request.path`. The query
         string is added so a member arriving from a campaign link returns as
         the same visitor. The fragment is deliberately not appended: Shopify
         validates `return_to`, and a rejected value strands the shopper on
         /account rather than failing loudly. */
      const field = modal.querySelector('input[name="return_to"]')
      if (field) field.value = window.location.pathname + window.location.search
      this.loginReturnFocus = document.activeElement
      window.setTimeout(() => {
        if (modal.hidden) return
        modal.querySelector('input:not([type="hidden"]), button[type="submit"]')?.focus()
      }, 40)
      return true
    }

    showFeatured(index) {
      if (!this.featuredSlides.length) return
      const total = this.featuredSlides.length
      this.featuredIndex = ((index % total) + total) % total
      this.featuredSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.featuredIndex
        slide.hidden = !active
        slide.classList.toggle('is-active', active)
      })
      this.featuredDots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.featuredIndex
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
    }

    scrollBoxes(direction) {
      const firstCard = this.track?.querySelector('.nf-box-card')
      const cardStep = firstCard ? firstCard.getBoundingClientRect().width + 16 : Math.min((this.track?.clientWidth || 0) * 0.82, 660)
      this.track?.scrollBy({ left: direction * cardStep, behavior: 'smooth' })
    }

    isInnerCircleBox(item) {
      const productId = Number(item.product_id)
      const properties = item.properties || {}
      const title = String(item.product_title || item.title || '')
      return this.knownBoxIds.includes(productId)
        || properties._fj_ic_box === 'true'
        || item.product_type === 'Monthly Shipment'
        || /subscription box/i.test(title)
    }

    cartHasInnerCircleBox(cart) {
      return (cart?.items || []).some((item) => this.isInnerCircleBox(item))
    }

    openSignin(trigger) {
      if (!this.signin) return
      this.signinTrigger = trigger
      this.signin.hidden = false
      document.documentElement.style.overflow = 'hidden'
      this.signin.querySelector('[data-close-signin]')?.focus()
    }

    closeSignin() {
      if (!this.signin) return
      this.signin.hidden = true
      document.documentElement.style.overflow = ''
      this.signinTrigger?.focus()
      if (this.revealPending) window.setTimeout(() => this.revealExclusives(), 260)
    }

    openQuickAdd(button) {
      if (!this.sheet || button.disabled) return
      this.activeTrigger = button
      this.activeSubscription = button.dataset.subscription === 'true'
      this.activeExclusive = button.dataset.exclusive === 'true'
      this.selectedVariant = null
      this.sheetImage.src = button.dataset.image || ''
      this.sheetImage.alt = button.dataset.title
      this.sheetTitle.textContent = button.dataset.title
      this.sheetMonth.textContent = button.dataset.month
      this.sheetStatus.textContent = ''
      this.sheetSubmit.textContent = this.submitLabel
      this.sheetChoices.replaceChildren()
      const variants = (button.dataset.variants || '').split(';').map((entry) => entry.split('~')).filter((entry) => entry[0])
      variants.forEach(([id, label], index) => {
        const choice = document.createElement('button')
        choice.type = 'button'
        choice.textContent = label
        choice.dataset.variantId = id
        choice.addEventListener('click', () => this.selectVariant(choice))
        this.sheetChoices.append(choice)
        if (index === 0) this.selectVariant(choice)
      })
      if (this.prospectPrice) {
        this.prospectPrice.textContent = this.activeSubscription
          ? this.dataset.subscriptionNote || ''
          : this.dataset.exclusiveNote || ''
      }
      this.sheet.hidden = false
      document.documentElement.style.overflow = 'hidden'
      this.sheet.querySelector('[data-close-quick-add]')?.focus()
    }

    selectVariant(choice) {
      this.sheetChoices.querySelectorAll('button').forEach((button) => button.classList.toggle('is-selected', button === choice))
      this.selectedVariant = choice.dataset.variantId
      this.sheetSubmit.disabled = !this.selectedVariant
    }

    closeQuickAdd() {
      if (!this.sheet) return
      this.sheet.hidden = true
      document.documentElement.style.overflow = ''
      this.activeTrigger?.focus()
      // Revision 5, item 9: a reveal that was held back while the sheet was
      // open runs now, after focus has settled.
      if (this.revealPending) window.setTimeout(() => this.revealExclusives(), 260)
    }

    async addSelection() {
      if (!this.selectedVariant || this.sheetSubmit.disabled) return

      // A missing selling plan must never become a silent one-time purchase.
      if (this.activeSubscription && !this.sellingPlan) {
        this.sheetStatus.textContent = 'This box cannot be added right now. Please try again shortly.'
        if (window.console) console.warn('[nosferatu-proof] Inner Circle selling plan id is not configured on this section.')
        return
      }

      this.sheetSubmit.disabled = true
      this.sheetStatus.textContent = 'Checking your cart…'
      try {
        const root = window.Shopify?.routes?.root || '/'
        const cartBeforeResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
        const cartBefore = await cartBeforeResponse.json()
        const hasInnerCircleBox = this.cartHasInnerCircleBox(cartBefore)

        // One Inner Circle box per cart. Checkout validation is still the authority.
        if (this.activeSubscription && hasInnerCircleBox) {
          throw new Error('Only one Inner Circle box can be in your cart at a time. Remove your current box before choosing another.')
        }
        if (this.activeExclusive && !this.memberAuthorized && !hasInnerCircleBox) {
          this.lockExclusives()
          throw new Error('Add an Inner Circle box first to unlock this member-exclusive item.')
        }

        this.sheetStatus.textContent = 'Adding your selection…'
        const item = { id: Number(this.selectedVariant), quantity: 1, properties: {} }
        if (this.activeSubscription) {
          item.properties._fj_ic_box = 'true'
          item.selling_plan = this.sellingPlan
        }
        if (this.activeExclusive) {
          item.properties._fj_ic_exclusive = 'true'
          item.properties._fj_requires_ic = 'true'
        }
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.')
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
        const cart = await cartResponse.json()
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }))
        if (this.activeSubscription) {
          this.unlockExclusives()
          /* Revision 5, item 9: this section's own add path. The dispatched
             `cart:updated` above already reaches the listener, but the theme's
             cart-watch is what emits `fj:cart-updated` and it may not be on
             every template — so the reveal is requested here too. It is held
             until the sheet closes (dialogIsOpen) and is idempotent. */
          this.hadBox = true
          this.revealExclusives()
        }
        this.sheetStatus.textContent = 'Added to your cart.'
        this.sheetSubmit.textContent = 'Added ✓'
        window.setTimeout(() => { this.sheetSubmit.textContent = this.submitLabel; this.sheetSubmit.disabled = false }, 1700)
      } catch (error) {
        this.sheetStatus.textContent = error.message || 'This selection could not be added. Please try another size.'
        this.sheetSubmit.disabled = false
      }
    }

    unlockExclusives() {
      this.classList.add('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = false })
    }

    /* ======================= REVISION 5, ITEM 9 =======================
       The reveal. Five rules, all of them the brief's:

         · never for an authenticated member — theirs was never locked, so
           there is nothing to unlock and nothing to say;
         · once per session, in sessionStorage, so a second box (or a second
           cart event, or a reload) does not drag the page around again;
         · instant jump under prefers-reduced-motion, no gate, no flourish;
         · never on top of an open dialog — the quick-add sheet, the sign-in
           dialog, the theme's login popup, the story section's gate or ring
           lightbox. It waits and runs when the page is calm again;
         · and it only ever SCROLLS and re-labels. No commerce state is
           changed here that `unlockExclusives()` has not already changed, and
           for a member-view-by-UTM visitor it still authorizes nothing.
       ================================================================= */
    dialogIsOpen() {
      if (this.sheet && !this.sheet.hidden) return true
      if (this.signin && !this.signin.hidden) return true
      const modal = document.getElementById('fj-login-modal')
      if (modal && !modal.hidden) return true
      const gate = document.querySelector('.nos-gate')
      if (gate && !gate.hidden) return true
      const lightbox = document.querySelector('.nos-lightbox')
      if (lightbox && !lightbox.hidden) return true
      // Anything at all that has locked the document's scroll is a dialog we
      // have not been told about. Do not climb over it.
      return document.documentElement.style.overflow === 'hidden'
    }

    revealExclusives() {
      if (this.memberAuthorized) return
      if (this.revealDone) return
      const target = this.querySelector('[data-exclusive-section]')
      if (!target) return

      if (this.dialogIsOpen()) {
        // Held, not dropped. The sheet's own close path calls back, and this
        // poll is the safety net for a dialog we do not own (the theme's login
        // popup). Bounded at ~20s so it can never poll forever.
        this.revealPending = true
        if (this.revealAttempts > 50) return
        this.revealAttempts += 1
        if (this.revealWait) window.clearTimeout(this.revealWait)
        this.revealWait = window.setTimeout(() => this.revealExclusives(), 400)
        return
      }

      this.revealPending = false
      this.revealDone = true
      try {
        window.sessionStorage.setItem(this.revealStorageKey, 'true')
      } catch (error) {
        // Without storage the reveal can repeat on a reload. It is a scroll
        // and a line of copy, so that degrades to mildly repetitive, not broken.
      }

      this.unlockExclusives()
      const intro = this.querySelector('[data-exclusive-intro]')
      const unlocked = this.querySelector('[data-exclusive-unlocked]')
      if (intro && unlocked) {
        intro.hidden = true
        unlocked.hidden = false
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' })

      const live = this.querySelector('[data-nf-live]')
      if (live) live.textContent = this.dataset.revealAnnounce || ''

      if (reduced) return
      const gate = this.querySelector('[data-exclusive-gate]')
      if (!gate) return
      gate.hidden = false
      // force a reflow so the keyframes start from the shut position
      void gate.offsetWidth
      this.classList.add('is-revealing')
      if (this.revealTimer) window.clearTimeout(this.revealTimer)
      this.revealTimer = window.setTimeout(() => {
        this.classList.remove('is-revealing')
        gate.hidden = true
      }, 2200)
    }

    lockExclusives() {
      if (this.memberAuthorized) return
      this.classList.remove('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = true })
    }
  }

  if (!customElements.get('nosferatu-proof')) customElements.define('nosferatu-proof', NosferatuProof)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snow-white-inner-circle"] && !Shopify.designMode) return;
  try {
    
  class SnowWhiteStory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return
      this.dataset.ready = 'true'
      const query = new URLSearchParams(window.location.search)
      const memberSignals = [query.get('ic_member'), query.get('utm_content')]
        .filter(Boolean)
        .map((value) => value.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_'))
      const memberEmailView = memberSignals.some((value) => ['1', 'true', 'ic_member', 'active_ic_member', 'active_inner_circle_member'].includes(value))
      if (memberEmailView) this.classList.add('is-member-view')
      this.memberView = this.classList.contains('is-member-view')
      this.charmStorageKey = `snow-white-ruby-apples:${window.location.pathname}`
      this.foundCharmIds = new Set()
      try {
        const storedCharms = JSON.parse(window.sessionStorage.getItem(this.charmStorageKey) || '[]')
        storedCharms.forEach((id) => this.foundCharmIds.add(String(id)))
      } catch (error) {
        this.foundCharmIds.clear()
      }
      this.charmsFound = this.foundCharmIds.size
      this.mirrorIndex = 0
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      this.progressBar = this.querySelector('[data-story-progress]')
      this.motionButton = this.querySelector('[data-motion-toggle]')
      this.motionLabel = this.querySelector('[data-motion-label]')
      this.musicButton = this.querySelector('[data-music-toggle]')
      this.musicLabel = this.querySelector('[data-music-label]')
      this.membershipCard = this.querySelector('[data-membership-card]')
      this.membershipBack = this.querySelector('[data-membership-back]')
      this.purchaseButton = this.querySelector('[data-purchase-reveal]')
      this.buyBoxSlot = this.querySelector('[data-buy-box-slot]')
      this.liveRegion = this.querySelector('[data-story-live]')
      this.counts = Array.from(this.querySelectorAll('[data-charm-count]'))
      this.questTally = this.querySelector('[data-quest-tally]')
      this.mirrorResult = this.querySelector('[data-mirror-result]')
      this.mirrorButton = this.querySelector('[data-mirror]')
      this.mirrorAnswer = this.querySelector('[data-mirror-answer]')
      this.mirrorMessages = Array.from(this.querySelectorAll('[data-mirror-message]')).map((node) => node.textContent.trim())
      this.completeMessage = this.querySelector('[data-mirror-complete]')?.textContent.trim() || ''
      this.reveals = Array.from(this.querySelectorAll('.sw-reveal'))
      this.chapters = Array.from(this.querySelectorAll('[data-chapter]'))
      this.productCards = Array.from(this.querySelectorAll('[data-product-card]'))
      this.logoutLink = this.querySelector('[data-member-logout]')
      this.onScroll = this.onScroll.bind(this)
      this.dockPurchaseBox = this.dockPurchaseBox.bind(this)
      this.motionButton?.addEventListener('click', () => this.toggleMotion())
      this.musicButton?.addEventListener('click', () => this.toggleMusic())
      if (!this.memberView) this.purchaseButton?.addEventListener('click', () => this.revealPurchase())
      this.mirrorButton?.addEventListener('click', () => this.askMirror())
      this.querySelectorAll('[data-charm]').forEach((button) => {
        if (this.foundCharmIds.has(button.dataset.charm)) button.disabled = true
        button.addEventListener('click', () => this.collectCharm(button))
      })
      this.productCards.forEach((card) => {
        card.dataset.slideIndex = '0'
        card.querySelector('[data-product-prev]')?.addEventListener('click', () => this.showProductSlide(card, Number(card.dataset.slideIndex) - 1))
        card.querySelector('[data-product-next]')?.addEventListener('click', () => this.showProductSlide(card, Number(card.dataset.slideIndex) + 1))
        card.querySelectorAll('[data-product-dot]').forEach((dot) => dot.addEventListener('click', () => this.showProductSlide(card, Number(dot.dataset.productDot))))
        this.showProductSlide(card, 0)
      })
      this.logoutLink?.addEventListener('click', (event) => this.logoutMember(event))
      this.syncCharmState()
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible')
        })
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' })
      this.reveals.forEach((item) => this.observer.observe(item))
      window.addEventListener('scroll', this.onScroll, { passive: true })
      if (!this.memberView) {
        if (document.readyState === 'complete') {
          window.setTimeout(this.dockPurchaseBox, 0)
        } else {
          window.addEventListener('load', this.dockPurchaseBox, { once: true })
        }
      }
      this.onScroll()
      if (query.get('show_join') === '1') {
        this.classList.add('is-returned-from-logout')
        window.setTimeout(() => this.membershipCard?.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'center' }), 120)
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect()
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('load', this.dockPurchaseBox)
      this.stopMusic()
    }

    toggleMotion() {
      const paused = this.dataset.motion === 'paused'
      this.dataset.motion = paused ? 'playing' : 'paused'
      this.motionButton?.setAttribute('aria-pressed', paused ? 'false' : 'true')
      if (this.motionLabel) this.motionLabel.textContent = paused ? this.dataset.pauseLabel : this.dataset.playLabel
    }

    async toggleMusic() {
      if (this.musicPlaying) {
        this.stopMusic()
        return
      }

      const AudioContext = window.AudioContext || window.webkitAudioContext
      if (!AudioContext) return
      this.audioContext = new AudioContext()
      await this.audioContext.resume()
      this.musicGain = this.audioContext.createGain()
      this.musicGain.gain.setValueAtTime(0.0001, this.audioContext.currentTime)
      this.musicGain.gain.exponentialRampToValueAtTime(0.24, this.audioContext.currentTime + 1.2)
      this.musicGain.connect(this.audioContext.destination)
      this.musicPlaying = true
      this.musicButton?.setAttribute('aria-pressed', 'true')
      if (this.musicLabel) this.musicLabel.textContent = this.dataset.pauseMusicLabel
      this.playMusicPhrase()
      this.musicTimer = window.setInterval(() => this.playMusicPhrase(), 9400)
    }

    stopMusic() {
      window.clearInterval(this.musicTimer)
      this.musicTimer = null
      this.musicPlaying = false
      this.musicButton?.setAttribute('aria-pressed', 'false')
      if (this.musicLabel) this.musicLabel.textContent = this.dataset.playMusicLabel
      if (!this.audioContext || !this.musicGain) return
      const context = this.audioContext
      const now = context.currentTime
      this.musicGain.gain.cancelScheduledValues(now)
      this.musicGain.gain.setValueAtTime(Math.max(0.0001, this.musicGain.gain.value), now)
      this.musicGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.55)
      window.setTimeout(() => context.close(), 650)
      this.audioContext = null
      this.musicGain = null
    }

    playMusicPhrase() {
      if (!this.audioContext || !this.musicGain) return
      const context = this.audioContext
      const start = context.currentTime + 0.08
      const notes = [523.25, 659.25, 783.99, 880, 783.99, 659.25, 587.33, 523.25]
      notes.forEach((frequency, index) => {
        const tone = context.createOscillator()
        const shimmer = context.createOscillator()
        const envelope = context.createGain()
        const shimmerEnvelope = context.createGain()
        const noteStart = start + (index * 0.82)
        tone.type = 'sine'
        tone.frequency.setValueAtTime(frequency, noteStart)
        shimmer.type = 'sine'
        shimmer.frequency.setValueAtTime(frequency * 2, noteStart)
        envelope.gain.setValueAtTime(0.0001, noteStart)
        envelope.gain.exponentialRampToValueAtTime(index % 2 ? 0.026 : 0.035, noteStart + 0.035)
        envelope.gain.exponentialRampToValueAtTime(0.0001, noteStart + 2.2)
        shimmerEnvelope.gain.setValueAtTime(0.0001, noteStart)
        shimmerEnvelope.gain.exponentialRampToValueAtTime(0.012, noteStart + 0.02)
        shimmerEnvelope.gain.exponentialRampToValueAtTime(0.0001, noteStart + 1.2)
        tone.connect(envelope)
        shimmer.connect(shimmerEnvelope)
        envelope.connect(this.musicGain)
        shimmerEnvelope.connect(this.musicGain)
        tone.start(noteStart)
        shimmer.start(noteStart)
        tone.stop(noteStart + 2.25)
        shimmer.stop(noteStart + 1.25)
      })
    }

    dockPurchaseBox() {
      if (this.memberView) return
      this.buyBox = document.querySelector('.shopify-section[id$="__snow_white_buy_box"]')
      if (!this.buyBox || !this.buyBoxSlot || window.Shopify?.designMode) return
      this.buyBoxSlot.append(this.buyBox)
    }

    revealPurchase() {
      if (this.memberView) return
      this.dockPurchaseBox()
      this.membershipCard?.classList.add('is-purchase-open')
      this.membershipBack?.setAttribute('aria-hidden', 'false')
      this.purchaseButton?.setAttribute('aria-expanded', 'true')
      this.buyBox?.classList.add('sw-buy-box--revealed')
      if (this.liveRegion) this.liveRegion.textContent = 'The membership choices are now open.'
      window.setTimeout(() => {
        const target = this.buyBoxSlot?.contains(this.buyBox) ? this.membershipCard : this.buyBox
        target?.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'start' })
        this.buyBox?.querySelector('select, input:not([type="hidden"]), button')?.focus({ preventScroll: true })
      }, this.prefersReducedMotion ? 0 : 720)
    }

    showProductSlide(card, index) {
      if (!card) return
      const slides = Array.from(card.querySelectorAll('[data-product-slide]'))
      const dots = Array.from(card.querySelectorAll('[data-product-dot]'))
      const caption = card.querySelector('[data-product-caption]')
      if (!slides.length) return
      const total = slides.length
      const activeIndex = ((index % total) + total) % total
      card.dataset.slideIndex = String(activeIndex)
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex
        slide.classList.toggle('is-active', active)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true')
      })
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
      const activeSlide = slides[activeIndex]
      if (caption && activeSlide?.dataset.caption) caption.textContent = activeSlide.dataset.caption
    }

    async logoutMember(event) {
      event.preventDefault()
      if (!this.logoutLink) return
      this.membershipCard?.classList.add('is-logging-out')
      if (this.liveRegion) this.liveRegion.textContent = 'Logging out and opening the gift purchase option.'
      try {
        await fetch(this.logoutLink.href, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          redirect: 'follow'
        })
      } catch (error) {
        // The top-level navigation below remains the reliable fallback.
      }
      window.location.assign(`${window.location.pathname}?show_join=1#snow-white-membership`)
    }

    syncCharmState() {
      this.charmsFound = this.foundCharmIds.size
      this.counts.forEach((count) => { count.textContent = String(this.charmsFound) })
      this.classList.toggle('has-charms', this.charmsFound > 0)
      this.questTally?.setAttribute('aria-hidden', this.charmsFound > 0 ? 'false' : 'true')
      if (this.charmsFound === 3) {
        this.classList.add('is-complete')
      }
    }

    collectCharm(button) {
      if (button.disabled) return
      button.disabled = true
      this.foundCharmIds.add(button.dataset.charm)
      try {
        window.sessionStorage.setItem(this.charmStorageKey, JSON.stringify(Array.from(this.foundCharmIds)))
      } catch (error) {
        // The quest still works when browser storage is unavailable.
      }
      this.syncCharmState()
      const message = this.charmsFound === 3
        ? this.dataset.completeLabel
        : `${this.charmsFound} ${this.dataset.foundLabel}`
      if (this.liveRegion) this.liveRegion.textContent = message
    }

    askMirror() {
      if (!this.mirrorAnswer) return
      if (!this.mirrorMessages.length) return
      const nextMessage = this.mirrorMessages[this.mirrorIndex % this.mirrorMessages.length]
      this.mirrorAnswer.classList.add('is-changing')
      this.mirrorButton?.classList.add('has-answer')
      window.setTimeout(() => {
        this.mirrorAnswer.textContent = nextMessage
        this.mirrorAnswer.classList.remove('is-changing')
        this.mirrorIndex += 1
      }, this.prefersReducedMotion ? 0 : 180)
    }

    onScroll() {
      if (this.scrollTicking) return
      this.scrollTicking = true
      window.requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect()
        const total = Math.max(1, rect.height - window.innerHeight)
        const progress = Math.min(1, Math.max(0, -rect.top / total))
        this.style.setProperty('--sw-progress', `${progress * 100}%`)
        if (!this.prefersReducedMotion && this.dataset.motion !== 'paused') {
          const heroProgress = Math.min(1, Math.max(0, -rect.top / Math.max(1, window.innerHeight)))
          this.style.setProperty('--sw-scroll', String(heroProgress))
          this.style.setProperty('--sw-hero-scale', String(1.07 - (heroProgress * 0.04)))
        }
        this.scrollTicking = false
      })
    }
  }

  if (!customElements.get('snow-white-story')) customElements.define('snow-white-story', SnowWhiteStory)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snow-white-membership-proof"] && !Shopify.designMode) return;
  try {
    
  class SnowWhiteProof extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return
      this.dataset.ready = 'true'
      const query = new URLSearchParams(window.location.search)
      const memberSignals = [query.get('ic_member'), query.get('utm_content')]
        .filter(Boolean)
        .map((value) => value.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_'))
      const memberEmailView = memberSignals.some((value) => ['1', 'true', 'ic_member', 'active_ic_member', 'active_inner_circle_member'].includes(value))
      if (memberEmailView) this.classList.add('is-member-view')
      this.memberView = this.classList.contains('is-member-view')
      this.memberAuthorized = this.dataset.memberAuthorized === 'true'
      if (this.memberView) {
        this.querySelectorAll('[data-archive-box]').forEach((button) => {
          button.setAttribute('aria-disabled', 'true')
          button.setAttribute('tabindex', '-1')
        })
      }
      this.featuredSlides = Array.from(this.querySelectorAll('[data-featured-slide]'))
      this.featuredDots = Array.from(this.querySelectorAll('[data-featured-dot]'))
      this.featuredIndex = 0
      this.track = this.querySelector('[data-box-track]')
      this.sheet = this.querySelector('[data-quick-add]')
      this.sheetImage = this.querySelector('[data-quick-image]')
      this.sheetTitle = this.querySelector('[data-quick-title]')
      this.sheetMonth = this.querySelector('[data-quick-month]')
      this.sheetChoices = this.querySelector('[data-quick-choices]')
      this.sheetSubmit = this.querySelector('[data-quick-submit]')
      this.sheetStatus = this.querySelector('[data-quick-status]')
      this.prospectPrice = this.querySelector('[data-quick-prospect-price]')
      this.memberPrice = this.querySelector('[data-quick-member-price]')
      this.querySelector('[data-featured-prev]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex - 1))
      this.querySelector('[data-featured-next]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex + 1))
      this.featuredDots.forEach((dot) => dot.addEventListener('click', () => this.showFeatured(Number(dot.dataset.featuredDot))))
      this.querySelector('[data-box-prev]')?.addEventListener('click', () => this.scrollBoxes(-1))
      this.querySelector('[data-box-next]')?.addEventListener('click', () => this.scrollBoxes(1))
      this.querySelectorAll('[data-open-quick-add]').forEach((button) => button.addEventListener('click', () => {
        if (this.memberView && button.hasAttribute('data-archive-box')) return
        this.openQuickAdd(button)
      }))
      this.querySelectorAll('[data-close-quick-add]').forEach((button) => button.addEventListener('click', () => this.closeQuickAdd()))
      this.sheetSubmit?.addEventListener('click', () => this.addSelection())
      this.onCartUpdated = (event) => {
        const hasBox = this.cartHasInnerCircleBox(event.detail?.cart)
        if (hasBox || this.memberAuthorized) this.unlockExclusives()
        else this.lockExclusives()
      }
      document.addEventListener('fj:cart-updated', this.onCartUpdated)
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.sheet?.hidden) this.closeQuickAdd()
      })
      this.showFeatured(0)
    }

    disconnectedCallback() {
      document.removeEventListener('fj:cart-updated', this.onCartUpdated)
    }

    showFeatured(index) {
      if (!this.featuredSlides.length) return
      const total = this.featuredSlides.length
      this.featuredIndex = ((index % total) + total) % total
      this.featuredSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.featuredIndex
        slide.hidden = !active
        slide.classList.toggle('is-active', active)
      })
      this.featuredDots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.featuredIndex
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
    }

    scrollBoxes(direction) {
      const firstCard = this.track?.querySelector('.sw-box-card')
      const cardStep = firstCard ? firstCard.getBoundingClientRect().width + 16 : Math.min((this.track?.clientWidth || 0) * .82, 660)
      this.track?.scrollBy({ left: direction * cardStep, behavior: 'smooth' })
    }

    isInnerCircleBox(item) {
      const productId = Number(item.product_id)
      const knownBoxIds = [
        7887560048718, 7887558082638, 7867028078670, 7853966491726, 7839072256078,
        7793404215374, 7787273846862, 7782868746318, 7769530073166, 7739526742094,
        7712452640846, 7690278338638, 7667317702734, 7639931584590, 7515393032270
      ]
      const properties = item.properties || {}
      const title = String(item.product_title || item.title || '')
      return knownBoxIds.includes(productId)
        || properties._fj_ic_box === 'true'
        || Boolean(item.selling_plan_allocation)
        || item.product_type === 'Monthly Shipment'
        || /subscription box/i.test(title)
    }

    cartHasInnerCircleBox(cart) {
      return (cart?.items || []).some((item) => this.isInnerCircleBox(item))
    }

    openQuickAdd(button) {
      if (button.disabled) return
      this.activeTrigger = button
      this.activeSubscription = button.dataset.subscription === 'true'
      this.activeExclusive = button.dataset.exclusive === 'true'
      this.selectedVariant = null
      this.sheetImage.src = button.dataset.image
      this.sheetImage.alt = button.dataset.title
      this.sheetTitle.textContent = button.dataset.title
      this.sheetMonth.textContent = button.dataset.month
      this.sheetStatus.textContent = ''
      this.sheetChoices.replaceChildren()
      const variants = (button.dataset.variants || '').split(';').map((entry) => entry.split('~')).filter((entry) => entry[0])
      variants.forEach(([id, label], index) => {
        const choice = document.createElement('button')
        choice.type = 'button'
        choice.textContent = label
        choice.dataset.variantId = id
        choice.addEventListener('click', () => this.selectVariant(choice))
        this.sheetChoices.append(choice)
        if (index === 0) this.selectVariant(choice)
      })
      this.prospectPrice.textContent = this.activeSubscription
        ? 'Your first subscription box is $19.98. The regular monthly rate is $39.95 after the promotional offer ends.'
        : 'Member-exclusive item pricing is shown above.'
      this.memberPrice.textContent = this.activeSubscription
        ? 'Your 25%-off member price is $29.96 before tax.'
        : 'Your member-exclusive item price is shown above.'
      this.sheet.hidden = false
      document.documentElement.style.overflow = 'hidden'
      this.querySelector('[data-close-quick-add]')?.focus()
    }

    selectVariant(choice) {
      this.sheetChoices.querySelectorAll('button').forEach((button) => button.classList.toggle('is-selected', button === choice))
      this.selectedVariant = choice.dataset.variantId
      this.sheetSubmit.disabled = !this.selectedVariant
    }

    closeQuickAdd() {
      this.sheet.hidden = true
      document.documentElement.style.overflow = ''
      this.activeTrigger?.focus()
    }

    async addSelection() {
      if (!this.selectedVariant || this.sheetSubmit.disabled) return
      this.sheetSubmit.disabled = true
      this.sheetStatus.textContent = 'Checking your cart…'
      try {
        const cartBeforeResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        const cartBefore = await cartBeforeResponse.json()
        const hasInnerCircleBox = this.cartHasInnerCircleBox(cartBefore)
        if (this.activeSubscription && hasInnerCircleBox) {
          throw new Error('Only one Inner Circle box can be in your cart at a time. Remove your current box before choosing another.')
        }
        if (this.activeExclusive && !this.memberAuthorized && !hasInnerCircleBox) {
          this.lockExclusives()
          throw new Error('Add an Inner Circle box first to unlock this member-exclusive item.')
        }

        this.sheetStatus.textContent = 'Adding your selection…'
        const item = { id: Number(this.selectedVariant), quantity: 1, properties: {} }
        if (this.activeSubscription) {
          item.properties._fj_ic_box = 'true'
          if (!this.memberAuthorized) item.selling_plan = Number(this.dataset.sellingPlan)
        }
        if (this.activeExclusive) {
          item.properties._fj_ic_exclusive = 'true'
          item.properties._fj_requires_ic = 'true'
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.')
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        const cart = await cartResponse.json()
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }))
        if (this.activeSubscription) this.unlockExclusives()
        this.sheetStatus.textContent = 'Added to your cart. Your selection is waiting for you.'
        this.sheetSubmit.textContent = 'Added ✓'
        window.setTimeout(() => { this.sheetSubmit.textContent = 'Add to cart'; this.sheetSubmit.disabled = false }, 1700)
      } catch (error) {
        this.sheetStatus.textContent = error.message || 'This selection could not be added. Please try another size.'
        this.sheetSubmit.disabled = false
      }
    }

    unlockExclusives() {
      this.classList.add('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = false })
    }

    lockExclusives() {
      if (this.memberAuthorized) return
      this.classList.remove('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = true })
    }
  }

  if (!customElements.get('snow-white-proof')) customElements.define('snow-white-proof', SnowWhiteProof)

  } catch(e) { console.error(e); }
})();
})();
